let config = {
    env: {
        version: '1.0.0'
    },
    development: {
        apiBaseURL: 'http://localhost:3000',
        clientBaseURL: 'http://localhost:8081',
        aws: {
            region: 'ap-southeast-1',
            publicBucket: 'farm-diary-resource-prod-publicbucket-yrjx0p08gdgt',
            identityPoolId: 'ap-southeast-1:c5d95cbf-e90e-4685-8eee-afe66b032c75',
            cognitoClientId: '29bmrtqqn0a27ckdr0l68a03ec',
            cognitoUserPoolId: 'ap-southeast-1_RhQik04Cf'
        }
    },
    production: {
        apiBaseURL: 'https://ckat3mbd6k.execute-api.ap-southeast-1.amazonaws.com/prod',
        clientBaseURL: 'https://farm-diary.metalsheep.com',
        aws: {
            region: 'ap-southeast-1',
            publicBucket: 'farm-diary-resource-prod-publicbucket-yrjx0p08gdgt',
            identityPoolId: 'ap-southeast-1:c5d95cbf-e90e-4685-8eee-afe66b032c75',
            cognitoClientId: '29bmrtqqn0a27ckdr0l68a03ec',
            cognitoUserPoolId: 'ap-southeast-1_RhQik04Cf'
        }
    }
};
let output = null;
if (process.env.NODE_ENV === 'development') {
    output = Object.assign(Object.assign({}, config.env), config.development);
}
else {
    output = Object.assign(Object.assign({}, config.env), config.production);
}
export default output;
